import { Header, SidebarTrigger } from '@ntconsult/aluma-react';
import { useTranslation } from 'react-i18next';
import { LanguageMenu } from './LanguageMenu';
import { ThemeMenu } from './ThemeMenu';
import { UserMenu } from './UserMenu';

export function AppHeader() {
  const { t } = useTranslation('common');
  return (
    <Header>
      <Header.Start>
        <SidebarTrigger label={t('sidebarToggle')} />
      </Header.Start>
      <Header.Center />
      <Header.End>
        <LanguageMenu />
        <ThemeMenu />
        <UserMenu />
      </Header.End>
    </Header>
  );
}
